module.exports = __webpack_public_path__ + "img/collection-engagementRingsEntwined.e7883e3.jpg";